import { render, staticRenderFns } from "./BaseRollWins.vue?vue&type=template&id=9b016f44&scoped=true&"
import script from "./BaseRollWins.vue?vue&type=script&lang=js&"
export * from "./BaseRollWins.vue?vue&type=script&lang=js&"
import style0 from "./BaseRollWins.vue?vue&type=style&index=0&id=9b016f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b016f44",
  null
  
)

export default component.exports